import { render, staticRenderFns } from "./view_pst_courses.vue?vue&type=template&id=373407f2"
import script from "./view_pst_courses.vue?vue&type=script&lang=js"
export * from "./view_pst_courses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports